export const getStoreState = (store)=> store.storeReducer;